export default __webpack_public_path__ + "static/media/acct-position-rates.c6add96f.png";